import * as React from 'react';

import RecoverPage from '@common/react/components/Pages/Recover/Recover';

import '@app/scss/pages/login.scss';
import '@app/scss/pages/recover.scss';

const Recover: React.FC = () => {
	return (
		<RecoverPage
			containerClassName="recover-page portal-form-center enter-page"
			withFieldTitle
		/>
	);
};

export default Recover;
